import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Component, Injectable, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { State } from '@app/state';
import { BaseComponent } from '@components/base.component';
import { GroupService } from '@services/group.service';
@Component({
  selector: 'app-group-sort',
  templateUrl: './group-sort.component.html',
  styleUrls: [],
})

@Injectable()
export class GroupSortComponent extends BaseComponent implements OnInit {

  public dataLoaded = false;
  public datasource: [];
  constructor(
    public activatedRoute: ActivatedRoute,
    public groupService: GroupService,
    public state: State,
  ) {
    super();
    this.setObjects({
      route: activatedRoute,
      state: state,
      modelService: groupService,
    });
  }

  ngOnInit(): void {
    this.modelServiceGetAll()
      .then(() => {
        this.datasource = this.dataSourceRows.sort(grp => grp.display_order);
        this.dataLoaded = true;
      });
  }

  drop($event: CdkDragDrop<string[]>) {
    const replacedElement = this.datasource[$event.currentIndex];
    const replacingElement = this.datasource[$event.previousIndex];

    // Swap the element
    const temp = this.datasource[$event.currentIndex];
    this.datasource[$event.currentIndex] = this.datasource[$event.previousIndex];
    this.datasource[$event.previousIndex] = temp;

    // TODO : These two requests should be handle in one request i-e updateDisplayOrder() at API side.
    // update the new/replacing element
    const uuid = $event.item.element.nativeElement.id;
    if (uuid) {
      const ind = $event.currentIndex + 1;
      this.groupService.patchById(uuid, { display_order: ind })
        .subscribe(result => this.ReplacedDisplayOrder(replacingElement, replacedElement));
    }
  }

  private ReplacedDisplayOrder(replacingElement, replacedElement) {
    // update the replaced element
    const uuid = replacedElement.uuid;
    if (uuid) {
      const ind = replacingElement.display_order;
      this.groupService.patchById(uuid, { display_order: ind }).subscribe();
    }
  }

  public closeSlideout() {
    this.state.message({ ['GroupIndexUpdate']: true });
    this.state.message({ slideoutHide: true });
  }
}
